

  document.addEventListener('DOMContentLoaded', () => {
  // alert('hello')
    new Imager(".delayed-cover-image", {
      availableWidths: {
        320: "xs",
        620: "s",
        940: "m",
        1440: "l"
      }
    });

    new Imager(".delayed-thumbnail", {
      availableWidths: {
        320: "square_thumbnail"
      }
    })

    var patients = document.getElementById('patients');
    var visitors = document.getElementById('visitors');
    const listItems = document.querySelectorAll('.tab--select--holder li');
    if(listItems.length > 0){
      listItems[0].addEventListener("click", function(e){
        e.preventDefault();
        var linkPatience = listItems[0].querySelector('a');
        var linkVisitor = listItems[1].querySelector('a');
        if(!linkPatience.className.includes('active')){
          linkPatience.classList.add("active");
          linkVisitor.classList.remove("active");
        }

        if(!patients.className.includes('active')){
          patients.classList.add("active");
          visitors.classList.remove("active");
        }

      });
      listItems[1].addEventListener("click", function(e){
        e.preventDefault();
        var linkPatience = listItems[0].querySelector('a');
        var linkVisitor = listItems[1].querySelector('a');
        if(!linkVisitor.className.includes('active')){
          linkPatience.classList.remove("active");
          linkVisitor.classList.add("active");
        }

        if(!visitors.className.includes('active')){
          patients.classList.remove("active");
          visitors.classList.add("active");
        }
      });
    }


    window.twttr = (function(d, s, id) {
      var js, fjs = d.getElementsByTagName(s)[0],
        t = window.twttr || {};
      if (d.getElementById(id)) return t;
      js = d.createElement(s);
      js.id = id;
      js.src = "https://platform.twitter.com/widgets.js";
      fjs.parentNode.insertBefore(js, fjs);

      t._e = [];
      t.ready = function(f) {
        t._e.push(f);
      };

      return t;
    }(document, "script", "twitter-wjs"));

  });



for (let i = document.getElementsByTagName("iframe"), j = 0; j < i.length; j++) {
  let parentElement = i[j]
  let divElement = document.createElement("div");
  divElement.classList.add("aspect-ratio__16_9");
  parentElement.parentNode.insertBefore(divElement, parentElement);
  divElement.appendChild(parentElement);
}



